import React from 'react';
import './style.css';
import { useHistory } from 'react-router-dom';
import Search from '@material-ui/icons/Search';

const CategoryComponent = ({ data, widthWindow = 2000 }) => {
  let history = useHistory();

  const goToBooks = (id, name) => {
    let params = new URLSearchParams();
    params.append('categories', id);
    history.push({
      pathname: '/books',
      search: params.toString(),
    });
  };

  const { id, image, name, parent } = data;
  return (
    <div className="slider-category-item-container" onClick={() => goToBooks(id, name)}>
      <div className="slider-category-item-title">{name}</div>
      <div className="slider-category-item-title-parent">{parent}</div>
    </div>
  );
};

export default CategoryComponent;
